<template>
    <div v-loading="dataLoading">
        <el-form
            :model="formData"
            :rules="rules"
            ref="formData"
            label-position="top"
        >
            <div class="group">
                <div class="page-group-title"><span>用户信息</span></div>
                <UserInfo :formData.sync="formData"></UserInfo>
            </div>
            <div class="group MT20">
                <div class="page-group-title"><span>收款信息</span></div>
                <ReceiptInfo :formData.sync="formData"></ReceiptInfo>
            </div>
            <div class="group MT20">
                <div class="page-group-title"><span>证件信息</span></div>
                <AccountInfo :formData.sync="formData" :type="3"></AccountInfo>
            </div>
            <div class="group MT20">
                <div class="page-group-title"><span>状态信息</span></div>
                <StatusInfo :formData.sync="formData"></StatusInfo>
            </div>
            <div class="group MT20">
                <el-button @click="goBack">返回</el-button>
                <el-button
                    v-if="$utils.have('/raise/receivables/updateInfo')"
                    type="primary"
                    @click="onSubmit"
                    :loading="btnLoading"
                    >提交</el-button
                >
            </div>
        </el-form>
    </div>
</template>

<script>
import UserInfo from './components/userInfo';
import ReceiptInfo from '@/views/finance/components/receiptInfo';
import AccountInfo from '@/views/finance//components/accountInfo';
import StatusInfo from './components/statusInfo';
export default {
    props:{
        id: {
            type: [Number, String],
            default: () => null
        }
    },
    components:{UserInfo,ReceiptInfo,AccountInfo,StatusInfo},
    data(){
        return{
            formData:{
                bankCityCode: '',
                bankProvinceCode: '',
                accountIdName: "",
                accountPic: "",
                accountType: 1,
                address: "",
                bankAccount: "",
                bankAddress: "",
                bankCardId: "",
                bankId: 1,
                // contractExpireTime: "",
                // contractSn: "",
                id: 0,
                otherPic: "",
                userEmail: "",
                userId: "",
                userName: "",
                userTelephone: "",
                pic1:'',
                pic2:'',
                licenseNumber:''
            },
            rules:{},
            dataLoading: false,
            btnLoading:false,
            redirect: this.$route.query.redirect || '/finance/raise/receivables/manage/list',
        }
    },
    mounted(){
        if (this.id) {
            this.formData.id = this.id;
            this.getDataDetail();
        }
    },
    methods:{
        //获取详情
        getDataDetail() {
            this.dataLoading = true;
            this.$request({
                url: "/raise/receivables/getInfoDetail",
                params: { id: parseInt(this.id) },
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                        const _accountPic = result.accountPic ? result.accountPic.split(',') : [];
                        this.formData = {
                            ...this.formData,
                            ...result,
                            pic1: _accountPic[0] || '',
                            pic2: _accountPic[1] || '', 
                        }
                    } else {
                        this.$message.error(msg || "获取信息失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("获取信息失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        //设置图片
        setAccountPic(){
            const _pic = [];
            if(this.formData.pic1) _pic.push(this.formData.pic1);
            if(this.formData.pic2) _pic.push(this.formData.pic2);

            this.formData.accountPic = _pic.toString(); 
        },
        //表单提交
        onSubmit(){
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    this.setAccountPic();
                    this.$request({
                        url: "/raise/receivables/updateInfo",
                        method: "POST",
                        data: this.formData,
                    })
                        .then((res) => {
                            //处理成功回调
                            const { state, msg } = res.data;
                            if (state && state == 1) {
                                this.goBack();
                            } else {
                                return this.$message.error(msg || "操作失败");
                            }
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                }
            });
        },
        //返回
        goBack() {
            if(this.redirect){
                this.$router.push({
                    path: this.redirect,
                });
            }else{
                this.$router.go(-1);
            }
        },
    }
}
</script>

<style lang="scss" scoped>
::v-deep .el-card{
    .el-col{
        line-height: 28px;
    }
}
</style>